/**
 * Created by: avinersan
 * Date: 31.08.2015, 13:37 
 */

(function () {
    'use strict';

    var id = 0;

    function isUndefined(v) {
        return typeof v == "undefined";
    }

    function generateId() {
        return ++id;
    }

    /*
    * Represents a collection of key-value pairs that are organized based on the hash code of the key.
    */
    function HashTable() {
        this.hashes = {};
    }
    
    HashTable.prototype = {
        constructor: HashTable,

        add: function (key, value) {
            var hashkey = this._getHash(key);
            if (isUndefined(hashkey))
                hashkey = generateId();
            this.hashes[hashkey] = value;
        },

        get: function( key ) {
            var hashkey = this._getHash(key);
            if (hashkey)
                return this.hashes[hashkey];
        },

        containsKey: function(key) {
            if (!this._hasHash(key))
                return false;
            return !isUndefined(this.get(key));
        },

        _getHash: function (key) {
            if (this._hasHash(key))
                return key._hashtableUniqueId || key;
        },

        _hasHash: function(key) {
            return typeof key === "string" || !isUndefined(key._hashtableUniqueId);
        }
    };

    TS.HashTable = HashTable;
})();